module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "outline": _vm.activeTab === 1,
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 0;
        _vm.setPreviousParams()
      }
    }
  }, [_vm._v("Recent and previous appointments")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "outline": _vm.activeTab === 0,
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 1;
        _vm.setUpcomingParams()
      }
    }
  }, [_vm._v("Upcoming appointments")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-chip', {
    staticClass: "mr-5 overline",
    attrs: {
      "label": ""
    }
  }, [_vm._v("\n      Today:\n      " + _vm._s(_vm.todaysDate) + "\n    ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('appointment-list', {
    attrs: {
      "dense": "",
      "group-by-month": "",
      "params": _vm.params,
      "title": _vm.title,
      "touch": _vm.fetchTrigger,
      "page-size": _vm.pageSize,
      "selected": _vm.selected,
      "loading": _vm.loading,
      "facets": "status,practitioner"
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      },
      "update:loading": function($event) {
        _vm.loading = $event
      },
      "update:request": _vm.setRequest
    }
  }, [_c('v-card-title', {
    staticClass: "py-0 hidden-xs-only",
    attrs: {
      "slot": "top"
    },
    slot: "top"
  }, [_c('v-spacer'), _vm._v(" "), _c('status-picker', {
    attrs: {
      "facets": _vm.facetCount.status
    },
    on: {
      "input": _vm.updateParams
    },
    model: {
      value: (_vm.statuses),
      callback: function($$v) {
        _vm.statuses = $$v
      },
      expression: "statuses"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _vm._l((_vm.practitioners), function(p) {
    return _c('v-chip', {
      key: p.id,
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.setSelectedPractitioner(p.id)
        }
      }
    }, [_c('v-avatar', {
      staticClass: "white--text mr-0 grey darken-2",
      attrs: {
        "dark": ""
      }
    }, [_vm._v(_vm._s(p.count))]), _vm._v(" "), (p.img) ? _c('v-avatar', {
      staticClass: "ml-1"
    }, [_c('v-img', {
      attrs: {
        "src": p.img
      }
    })], 1) : _vm._e(), _vm._v("\n\n        " + _vm._s(p.full_name) + "\n\n        "), (_vm.isSelectedPractitioner(p.id)) ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]) : _vm._e()], 1)
  })], 2)], 1), _vm._v(" "), (_vm.relationship && _vm.relationship.id) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "top": "",
      "right": "",
      "small": "",
      "dark": "",
      "absolute": "",
      "color": "pink"
    },
    on: {
      "click": function($event) {
        return _vm.launchCreateAppointment({
          relationship: _vm.relationship
        })
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bcb3498","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/detail/ClientAppointments.vue
// module id = 1437
// module chunks = 9